import React, { useEffect, useState } from "react";
import liracrypt from "../components/Liracrypt/liracrypt";
import { Form, Row, Col, Modal, notification, Table, Card, Spin } from "antd";
import Button from "../components/ReportFormGenerator/Button/Button";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../components/ApiErrorComp/SessionError";
import { LoadingOutlined } from "@ant-design/icons";
import InputIdentify from "./InputCreater/InputCreater";
import StablePrime from "../components/Tables/StablePrime";
import moment from "moment";
import { useParams, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import RoutePage from "../components/RoutePage";
import queryString from "query-string";
import JSONEditor from "../components/PhantomZen/ZenJSONInput";
import ZenFormInput from "./InputCreater/ZenFormInput";
import DynamicZenChart from "./DynamicZenChart";
import Calendar_Calibration from "../components/Calendar/Calendar_Calibration";


function PhantomPrime({
  showJSONeditor,
  editSingleColumn,
  setPageHeader,
  zenTable,
  urlEndpoint = '/miscellaneous/pageconfig',
  urlData = {},
  pageName,
  colSpan,
  btnMargin,
  extraData,
  urlMethod,
  filterType = "",
  button = "default",
  layoutPosition,
  showInput = true,
  className
}) {
  // if (setPageHeader) {
  //   setPageHeader(pageName);
  // }
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const [pageLoading, setPageLoading] = useState(false);
  const [modalElement, setModalElement] = React.useState(null);
  const [url, setUrl] = React.useState(null);
  const [method, setMethod] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loginError, setLoginError] = React.useState(false);
  const [render, setRender] = React.useState(true);
  const [formData, setFormData] = React.useState(null);
  const [fro, setFro] = React.useState(null);
  const [showInp, setShowInp] = React.useState(showInput);
  const { docNo } = useParams();
  const [config, setConfig] = useState()
  const [form] = Form.useForm();
  const LocalDict = [];
  const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker", "slicer"];

  const now = new Date();

  function setPhantomData(key, value) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + 28800000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getPhantomData(key) {
    const itemStr = localStorage.getItem(key + "Page");
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    // if (now.getTime() > item.expiry) {
    //   // If the item is expired, delete the item from storage
    //   // and return null
    //   localStorage.removeItem(key);
    //   return null;
    // }
    return item.value;
  }

  useEffect(() => {
    if (modalElement) {
      if (search.includes("autoSubmit=true") || urlData?.autoSubmit) {
        setTimeout(() => {
          form.submit();
        }, 500);
        // document.getElementById("submitButtonForm").click();
      }
    }

  }, [modalElement]);

  React.useEffect(() => {
    const d = getPhantomData(urlData["dictName"]);
    if (d) {
      setUrl(d.config?.url);
      setMethod(d.config?.method);
      setModalElement(d.config?.modalElements);
      setRender(false);
    } else {
      console.log('test3');
      setPageLoading(true);
      setFormData(null);
      form.resetFields();
      ////
      if (!urlMethod) {
        liracrypt
          .get(urlEndpoint, { ...searchParams, ...urlData })
          .then((res, req) => {
            // setPhantomData(urlData["dictName"], res.data);
            if (setPageHeader) {
              setPageHeader(res.data.config.pageTitle || pageName);
            };
            setConfig({
              ...res.data.config,
              respTyp: res.data.config.respTyp,
              queryLayout: res.data.config.queryLayout
            });
            setUrl(res.data.config?.url);
            setMethod(res.data.config?.method);
            setModalElement(res.data.config?.modalElements);
            setRender(false);
            setPageLoading(false);
          })
          .catch((err) => {
            console.log(err);
            if (err.response !== undefined) {
              if (err.response.status !== 401) {
                // ApiErrorComp(err.response.status);
              } else {
                setLoginError(true);
              }
            }
          });
      } else {
        if (urlMethod === "POST") {
          liracrypt
            .post("/miscellaneous/pageconfig", urlData)
            .then((res, req) => {


              //  setPhantomData(urlData["dictName"], res.data);

              setUrl(res.data.config?.url);
              setMethod(res.data.config?.method);
              setModalElement(res.data.config?.modalElements);
              setRender(false);
            })
            .catch((err) => {
              console.log(err);
              if (err.response !== undefined) {
                if (err.response.status !== 401) {
                  // ApiErrorComp(err.response.status);
                } else {
                  setLoginError(true);
                }
              }
            });
        }
        if (urlMethod === "PATCH") {
          liracrypt
            .patch("/miscellaneous/pageconfig", urlData)
            .then((res, req) => {


              //  setPhantomData(urlData["dictName"], res.data);

              setUrl(res.data.config?.url);
              setMethod(res.data.config?.method);
              setModalElement(res.data.config?.modalElements);

              setRender(false);
            })
            .catch((err) => {
              console.log(err);
              if (err.response !== undefined) {
                if (err.response.status !== 401) {
                  // ApiErrorComp(err.response.status);
                } else {
                  setLoginError(true);
                }
              }
            });
        }
      }
      ////
    }

    return () => { };
  }, [JSON.stringify(searchParams)]);

  const onFinish = (value) => {
    setFormData(null);
    setTimeout(() => {
      Object.keys(value).forEach((key, i) => {

        if (value[key]) {
          if (Array.isArray(value[key]) && LocalDict[key]) {
            value[
              LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
            ] = dayjs(value[key][0]).format(LocalDict[key]).toString();
            value[
              LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"
            ] = dayjs(value[key][1]).format(LocalDict[key]).toString();
            delete value[key];
          } else {
            if (LocalDict[key]) {
              value[key] = dayjs(value[key]).isValid()
                ? dayjs(value[key]).format(LocalDict[key]).toString()
                : value[key];
            }
            // } else {
            //   value[key] = moment(value[key]).isValid()
            //     ? moment(value[key]).toString()
            //     : value[key];
            // }
          }
        }
      });

      Object.keys(value).forEach((element) => {
        if (Array.isArray(value[element])) {
          let filtered = value[element].filter(function (el) {
            return el != null;
          });
          let temp = filtered.toString();
          value[element] = "[" + temp + "]";
        }
      });
      setFormData({ ...searchParams, ...value });
    }, 100);


  };

  const DataTable = ({ url, method }) => {
    if (config?.output?.response === 'zenChart') {
      return (
        <>
          {
            formData ? (
              <DynamicZenChart
                api={url}
                urlData={{ ...urlData || {}, ...searchParams, ...formData }}
              />
            ) : <></>
          }
        </>
      )
    }
    if (config?.output?.response === 'calendar') {
      return (
        <>
          {
            formData ? (
              <Calendar_Calibration
                api={url}
                urlData={{ ...urlData || {}, ...searchParams, ...formData }}
              />
            ) : <></>
          }
        </>
      )
    }
    if (showJSONeditor) {
      return (
        <>
          {
            formData ? (
              <JSONEditor method={method} url={url} data={{ ...urlData || {}, ...searchParams, ...formData }} identity="DataTable" />
            ) : <></>
          }
        </>
      )
    }
    return (
      <>
        {formData ? (
          searchParams.tblQty ?
            <>
              {
                Array.from({ length: searchParams.tblQty }).map((_, i) => (
                  <div>
                    <StablePrime method={method} editSingleColumn={editSingleColumn} url={url} data={{ ...urlData || {}, ...searchParams, ...formData, tblIndx: `table-${i}` }} identity="DataTable" />
                  </div>
                ))
              }
            </> :
            <StablePrime showJSONeditor={showJSONeditor} method={method} editSingleColumn={editSingleColumn} zenTable={zenTable} url={url} data={{ ...urlData || {}, ...searchParams, ...formData }} identity="DataTable" />
        ) : (
          <></>
        )}
      </>
    );
  };

  React.useEffect(() => {
    let queryData = {};
    const params = new URLSearchParams(window.location.search);

    for (var key of params.keys()) {
      queryData[key] = params.get(key);
      if (key === "showInput") {
        setShowInp(params.get(key) == "true" ? true : false);
        setFormData(queryData);
      }
    }

    // console.log(url);
    // console.log(d);

    // Object.keys(params).forEach((data, index) => {
    //   console.log(params);
    //   queryData[data] = params.get(data);
    // });
    // setFormData(queryData);
  }, []);

  const queryElements = (data, index) => {
    if (data.visible !== false) {
      return (
        <React.Fragment key={index}>
          <ZenFormInput
            LocalDict={LocalDict}
            queryLayout={config.queryLayout}
            pageType={"phantom"}
            onChange={(data.typ === 'dropDown' && data.submitOnChange) ? () => form.submit() : undefined}
            layoutPosition={layoutPosition}
            colSpan={data.colSize || 12}
            form={form}
            name={data["data_index"]}
            pname={data["p_data_index"]}
            label={data["label"]}
            defaultValue={data["default"]}
            defaultFrom={data["defaultFrom"]}
            defaultTo={data["defaultTo"]}
            typ={data["typ"]}
            disabled={data["readOnly"]}
            source={data["source"]}
            sourceParams={data["sourceParams"]}
            auxParams={data["auxParams"]}
            format={data["format"]}
            errorMessage={data["errorMessage"]}
            placeHolder={data["placeHolder"]}
            required={data["required"]}
            options={data["data"]}
            from={data["data_index_from"]}
            to={data["data_index_to"]}
            url={data["url"]}
            includeAll={data["includeAll"]}
            multiSelect={data["multiSelect"]}
            // searchable={data["isSearchable"]}
            searchable={true}
            data={data}

          />
        </React.Fragment>
      )
    }
  }


  return (
    <>
      <SessionError loginError={loginError} />
      <div className={className || ''} style={filterType === 'sideBar' ? { display: 'flex' } : {}}>
        {
          pageLoading ?
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
            </div> :

            <>
              {modalElement && showInp ? (
                <div className={`AuditSection CreateAudit ${filterType}`} style={{ padding: "10px" }}>
                  <div className={`ThemeForm ${className || 'phantom'}-form`}>
                    <Form
                      name={`ReportForm `}
                      form={form}
                      labelWrap={true}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      layout="horizontal"
                      colon={false}
                      onFinish={onFinish}
                      size="large"
                    >
                      <div
                        className="settingModal"
                        style={{
                          maxHeight: "400px",
                          overflowY: "scroll",
                          overflowX: "hidden",
                        }}
                      >
                        <Row>
                          {modalElement.map((data, index) => {

                            if (dtArray.includes(data["typ"])) {

                              LocalDict[data["data_index"]] = data["format"]
                                ? data["format"]
                                : "YYYY-MM-DD hh:mm:ss";
                              LocalDict["data_index_from"] = data["data_index_from"];
                              LocalDict["data_index_to"] = data["data_index_to"];
                            }
                            if (data.visible !== false) {
                              return (
                                <>
                                  {
                                    config?.queryLayout ?
                                      queryElements(data, index) :
                                      <Col span={24}>
                                        <Row justify={"center"}>
                                          {
                                            queryElements(data, index)
                                          }
                                        </Row>
                                      </Col>
                                  }
                                </>
                              );
                            }
                          })}
                        </Row>

                      </div>
                      {
                        config?.hide_reset && config?.hide_submit ?
                          <></> :
                          <Row gutter={24} justify="center">
                            <Col span={24}>
                              {
                                button === 'default' ?
                                  <Button
                                    submitBtnId={"phantomPrimeSbmt"}
                                    form={form}
                                    hide_submit={config?.hide_submit}
                                    // marginLeft={btnMargin ? btnMargin : "320px"}
                                    loading={loading}
                                    cancelButtonText={config?.hide_reset ? false : "Reset"}
                                    submitButtonText={"Submit"}
                                  //  resetButton={true}
                                  /> :
                                  <Button width={"100%"} submitButtonText="Search" form={form} loading={loading} />
                              }
                            </Col>
                          </Row>
                      }

                    </Form>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "80vh",
                    }}
                  >
                    <LoadingOutlined
                      style={{ fontSize: 80, color: "#007bff" }}
                      spin
                    />
                  </div>
                </>
              )}
              <>
                {url && Array.isArray(url) ? (
                  <>
                    {url.map((data, index) => {

                      return <DataTable url={data} />;
                    })}
                  </>
                ) : (
                  <>
                    {DataTable({ url, method })}
                    {/* <DataTable url={url} method={method} /> */}
                  </>
                )}
              </>
            </>
        }
      </div>
    </>
  );
}

export default PhantomPrime;
